import { VUE_APP_ROOT_API } from '@/helpers/env'
import { LOG_LEVEL_INFORMATION, LOG_LEVEL_WARNING, LOG_LEVEL_ERROR, LOG_LEVEL_CRITICAL } from '@/consts/enums'

const MAX_MSG_QUEUE = 5

let logMessage = []
let sendMsgTimeout = null

export default {
  logInformation: msg => log(msg, LOG_LEVEL_INFORMATION),
  logWarning: msg => log(msg, LOG_LEVEL_WARNING),
  logError: msg => log(msg, LOG_LEVEL_ERROR),
  logCritical: msg => log(msg, LOG_LEVEL_CRITICAL)
}

function log(message, level) {
  if (!message) message = ''
  else if (message instanceof Error) message = message.toString()
  else message = JSON.stringify(message)

  logMessage.push({ message, level })
  resetOrSend()
}

async function sendMsg() {
  if (logMessage.length === 0) return

  try {
    await fetch(`${VUE_APP_ROOT_API}/log`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(logMessage)
    })

    logMessage = []
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}

function resetOrSend() {
  if (logMessage.length >= MAX_MSG_QUEUE) {
    sendMsg()
  } else {
    resetTimeout()
  }
}

function resetTimeout() {
  clearTimeout(sendMsgTimeout)
  startTimeout()
}

function startTimeout() {
  sendMsgTimeout = setTimeout(sendMsg, 1000)
}
